import {AbstractValidator, ValidationOptions} from "@ha/formhandler";
import {passwordRuleViolations} from "../helpers/password-rule";

/** Rule S6 for a new password (`password-rule.ts`) as a field validator; gates the "Passwort ändern" button. */
export class PasswordRuleValidator extends AbstractValidator<string, ValidationOptions<string>> {

    protected get defaultValidationMessage(): string {
        return `Das neue Passwort erfüllt die Passwortregel nicht.`;
    }

    protected validate(value: string): boolean {
        return passwordRuleViolations(value ?? '').length === 0;
    }

}
